import { memo, useCallback, useMemo, useRef } from "react"

import { URL_ARRAY_PARAM_SEPARATOR } from "constants/constants"
import { usePaginationFromURL } from "hooks/usePaginationFromURL"

import { FilterPopover } from "components/FilterComponents/FilterPopover/FilterPopover"
import { FilterType } from "components/FilterComponents/FilterPopover/types"

import { OrderFilterKey, VALID_ORDER_STATUSES } from "../../constant"
import { createStatusFilterOptions } from "../../utils"

interface StatusFilterProps {
    isFree?: boolean
    handleUpdateParam: (paramName: string, paramValue: string) => void
}

export const StatusFilter = memo(({ isFree, handleUpdateParam }: StatusFilterProps) => {
    const { statuses } = usePaginationFromURL('orders')

    const handleUpdateParamRef = useRef(handleUpdateParam)

    handleUpdateParamRef.current = handleUpdateParam

    const statusOptions = useMemo(() =>
        createStatusFilterOptions(VALID_ORDER_STATUSES, isFree)
        , [isFree])

    const filterOptions = useMemo(() =>
        statusOptions.map(status => ({
            label: status.text,
            value: status.statuses
        }))
        , [statusOptions])

    const handleStatusesSelectionChange = useCallback((selectedItems: string[]) => {
        if (selectedItems.length === 0) {
            handleUpdateParamRef.current(OrderFilterKey.STATUSES, '')
            return
        }

        const encodedStatuses = encodeURIComponent(
            selectedItems.join(URL_ARRAY_PARAM_SEPARATOR)
        )
        handleUpdateParamRef.current(OrderFilterKey.STATUSES, encodedStatuses)
    }, [])

    return (
        <FilterPopover
            label="Status"
            options={filterOptions}
            selectedItems={statuses}
            onSelectionChange={handleStatusesSelectionChange}
            filterType={FilterType.CHECKLIST}
        />
    )
})